import { IUsuarioSNP } from '@/shared/model/usuario-snp.model';
import { IInstitucionSNP } from '@/shared/model/institucionSNP.model';
import { Cuota, IPlanDeEstudios } from '@/shared/model/solicitud.model';
import { ILieSnp } from '@/shared/model/snp/lie.model';
import { IPronaceSnp } from '@/shared/model/snp/pronaces.model';
import { IProgramaIntegrado } from '@/shared/model/snp/programa-integrado.model';
import { OpcionTerminalSnp } from '@/shared/model/snp/opcion-terminal.model';
import { RegistroTemaSnp } from '@/shared/model/snp/temas.model';
import { AreaConocimiento } from '@/shared/model/snp/campo-conocimiento.model';
import { Area } from '@/shared/model/enumerations/area';
import { InstanciaColegiada } from '@/entities/snp/administracion/programas/programa.model';
import { IVigencia } from '@/shared/model/vigencia.model';
export interface IPrograma {
  id?: string | null;
  clave?: string | null;
  nombre?: string | null;
  integrado?: boolean | null;
  cveModalidad?: string | null;
  modalidad?: string | null;
  cveGrado?: string | null;
  grado?: string | null;
  cveOrientacion?: string | null;
  orientacion?: string | null;
  cveCaracteristica?: string | null;
  caracteristica?: string | null;
  cveTipo?: string | null;
  tipo?: string | null;
  fechaCreacion?: string | null;
  fechaInicio?: string | null;
  anteDgp?: string | null;
  rvoe?: string | null;
  paginaWeb?: string | null;
  tipoEspecial?: string | null;
  instituciones?: IInstitucionSNP[];
  nombreInstitucion?: string | null;
  asistentes?: IUsuarioSNP[];
  properties?: object | null;
  cuota?: Cuota | null;
  planDeEstudios?: IPlanDeEstudios | null;
  aprobada?: boolean | null;
  estadoUltimaSolicitud?: string | null;
  comentarios?: boolean | null;
  area?: Area | null;
  numeroDeActa?: string | null;
  fechaAprobacion?: string | null;
  maximaInstancia?: InstanciaColegiada | null;
  vigencia?: IVigencia | null;
}

export class Programa implements IPrograma {
  constructor(
    public id?: string | null,
    public clave?: string | null,
    public nombre?: string | null,
    public cveModalidad?: string | null,
    public modalidad?: string | null,
    public cveGrado?: string | null,
    public grado?: string | null,
    public cveOrientacion?: string | null,
    public orientacion?: string | null,
    public cveCaracteristica?: string | null,
    public caracteristica?: string | null,
    public cveTipo?: string | null,
    public tipo?: string | null,
    public fechaCreacion?: string | null,
    public fechaInicio?: string | null,
    public anteDgp?: string | null,
    public rvoe?: string | null,
    public paginaWeb?: string | null,
    public integrado?: boolean | null,
    public tipoEspecial?: string | null,
    public instituciones?: IInstitucionSNP[],
    public nombreInstitucion?: string | null,
    public estatus?: string | null,
    public asistentes?: IUsuarioSNP[],
    public coordinadores?: IUsuarioSNP[],
    public properties?: object | null,
    public cuota?: Cuota | null,
    public planDeEstudios?: IPlanDeEstudios | null,
    public pronace?: IPronaceSnp | null,
    public lies?: ILieSnp[] | null,
    public programasIntegrados?: IProgramaIntegrado[] | null,
    public areasConocimiento?: AreaConocimiento[] | null,
    public opcionesTerminales?: OpcionTerminalSnp[] | null,
    public temas?: RegistroTemaSnp[] | null,
    public aprobada?: boolean | null,
    public estadoUltimaSolicitud?: string | null,
    public comentarios?: boolean | null,
    public area?: Area | null,
    public numeroDeActa?: string | null,
    public fechaAprobacion?: string | null,
    public maximaInstancia?: InstanciaColegiada | null,
    public vigencia?: IVigencia | null
  ) {}

  static fromObject(data: IPrograma): Programa {
    const programa = new Programa();
    for (const [key, value] of Object.entries(data)) {
      programa[key] = value;
    }
    if (programa.instituciones && programa.instituciones.length > 0) {
      if (programa.area === Area.GPLN) {
        programa.nombreInstitucion = programa.instituciones[0].nombreInstitucion;
      } else {
        for (const institucion of programa.instituciones) {
          for (const sede of institucion.sedes) {
            if (sede.postulante) {
              programa.nombreInstitucion = institucion.nombreInstitucion + ' - ' + sede.sede + ' - ' + sede.nombreDependencia;
            }
          }
        }
      }
    }
    return programa;
  }
}
